import { render, staticRenderFns } from "./lecturerHomepageDefault.vue?vue&type=template&id=41957e82&scoped=true"
import script from "./lecturerHomepageDefault.vue?vue&type=script&lang=js"
export * from "./lecturerHomepageDefault.vue?vue&type=script&lang=js"
import style0 from "./lecturerHomepageDefault.vue?vue&type=style&index=0&id=41957e82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41957e82",
  null
  
)

export default component.exports